<template>
  <Row>
    <Col>
      <div class="d-flex">
        <div class="icon-stepper rounded-circle primary">
          <InfoText text="1" inline class="mt-n1 ml-2" style="width: 15px; font-size:15px"/>
        </div>
        <div class="ml-2">
          <p class="text-paragraph-2 gray--text text--scale500">Transfira o conteúdo do seu site para Locaweb</p>
        </div>
      </div>
      <div style="border-left: 1px solid" class="ml-3 py-4 mt-2">
        <div>
          <p class="text-caption ml-4 mt-n1">
            Instalamos este site com um domínio temporário para o seu conforto. <br> Dessa forma, você poderá transferir o conteúdo do seu site para cá, sem retirá-lo do ar. <br> Em caso de dúvidas, veja nosso artigo <span @click="trackSelectionFieldTransfer" style="text-decoration:none"><a href="https://ajuda.locaweb.com.br/wiki/transferindo-um-site-wordpress-de-outro-provedor-para-a-locaweb/" target="_blank" style="text-decoration:none" >como transferir meu site</a></span>.
          </p>
        </div>
      </div>
      <div class="d-flex mt-4">
        <div class="icon-stepper rounded-circle primary">
          <InfoText text="2" inline class="mt-n1 ml-2" style="width: 15px; font-size:15px"/>
        </div>
        <div class="ml-2">
          <p class="text-paragraph-2 gray--text text--scale500">Altere o domínio temporário</p>
        </div>
      </div>
      <div class="ml-3 py-4 mt-2">
        <div>
          <p class="text-caption ml-4 mt-n5">
            Depois que você concluir a transferência de arquivos, <span @click="trackSelectionFieldDomain" style="text-decoration:none"><a :href="changeDomain" style="text-decoration:none">altere o domínio</a></span> deste site para o domínio definitivo.<br> Isso terminará a transferência do site para cá.
          </p>
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
import { Row, Col, InfoText } from '@locaweb/design-system-vue'
export default {
  name: 'AccordionTransfer',
  props: {
    site: {
      type: Object,
      required: true
    }
  },
  components: {
    Row,
    Col,
    InfoText
  },
  methods: {
    trackSelectionFieldTransfer () {
      const gEvents = this.$gEvents('listaDeSites')
      this.$dga.event(gEvents.comoTransferirMeuSite)
    },
    trackSelectionFieldDomain () {
      const gEvents = this.$gEvents('listaDeSites')
      this.$dga.event(gEvents.alterarDominio)
    }
  },
  computed: {
    changeDomain () {
      const link = `${this.site.id}/change-domain`
      return link
    }
  }
}
</script>

<style>
.icon-stepper{
  width: 23px;
  height: 23px;
}
</style>
